export const isOpen = state => state.isOpen;

export const requiredPlan = state => state.requiredPlan;

export const allowClose = state => state.allowClose;
